import moment from 'app/modules/datetime';
import lang from 'app/lib/moment/lang/pt';

moment.lang('pt', lang);



// WEBPACK FOOTER //
// ./src/web/js/app/datetime.pt.js